import { render, staticRenderFns } from "./TheDocumentLineItems.vue?vue&type=template&id=6b654685&scoped=true&"
import script from "./TheDocumentLineItems.vue?vue&type=script&lang=js&"
export * from "./TheDocumentLineItems.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentLineItems.vue?vue&type=style&index=0&id=6b654685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b654685",
  null
  
)

export default component.exports